/*
 * @Description:
 * @Date: 2022-04-19 16:03:38
 */
import { reactive, ref } from 'vue';
import { defineStore } from 'pinia';
import appStore from '@/store';

import { LoginUserInfo } from '../data-source/types';
import type { FormData } from '../types/index';

const baseLoginData = () => {
  return {
    phone: null,
    phone2: null, // 验证手机号回显
    password: '',
    userName: '',
    activeName: null
  };
};
const name = 'useLoginStore';
export const useSetup = defineStore(
  name,
  () => {
    const info = reactive<LoginUserInfo>({
      forgetThePassword: 0,
      authentication: null,
      loginUserId: null, // userId
      name: null,
      phone: null,
      entpName: null,
      entpId: null, //企业id
      isSuperAdministrator: 0, // 是否是超级管理员0否 1是
      entpType: null, // 主体类型: 1:工业 2:服务商 3:供应商
      duty: null, // 用户当前职能
      duties: null, //  具有哪些职能，这个是算出来的1：向日葵功能 2：工业功能 3：服务商功能 4：供应商功能 5：监管功能 6 运营基地
      entpAuthStatus: null,
      isSkip: null,
      entAuditStatus: null,
      isBaseAsp: null
    });

    // 手机号、密码，组件切换回显使用
    const loginData = ref<
      FormData & { activeName?: 'bycode' | 'bypassword'; phone2?: string }
    >(baseLoginData());
    /**
     * @description: 登录、注册/找回都先同步info
     */
    const setInfo = payload => {
      Object.assign(info, payload);
    };
    /**
     * @description: 登录。 忘记密码/注册中设置密码后才是真正的登录，当真正登录时（手机/账号登录，设置密码）才会同步到appStore user中
     */
    const login = async () => {
      // 只存储有用字段
      const { forgetThePassword, ...fields } = info;
      await appStore.useUserStoreSetup.login(fields);
      clearLoginData();
    };

    const setLoginData = data => {
      loginData.value = { ...loginData.value, ...data };
    };
    const clearLoginData = () => {
      loginData.value = baseLoginData();
    };
    return {
      info,
      setInfo,
      login,
      loginData,
      setLoginData,
      clearLoginData
    };
  },
  {
    persist: false
  }
);
